/**
 * Contains code for event tracking with Google Analytics and Adobe Analytics
 * (creator)
 *
 * Following events get tracked:
 * - product viewed (quickview opened from Zmags)
 * - product added to cart (from quickview, which was opened from Zmags)
 * - cart viewed (if a product in the cart was added from Zmags)
 * - go to checkout (if a product in the cart was added from Zmags)
 * - order placed (if a product in the order was added from Zmags)
 */

(function(){

	var ZMAGSSOURCE = 'creator',
		zmagsSettings = window.__zmags.demandware.analytics.creator.settings,
		zmagsData = window.__zmags.demandware.analytics.creator.data;

	function trackQuickviewOpened(pid, zmagsSource) {
		var action = 'Zmags QuickView Launched';
		trackZmagsEvent(action, zmagsSource, pid);
	}

	function trackAddToCart(pid, zmagsSource, qty) {
		var action = 'Zmags Add To Cart';
		trackZmagsEvent(action, zmagsSource, pid, qty);
	}

	function trackCartViewed() {
		var action = 'Zmags Cart Viewed';
		trackZmagsEvent(action, zmagsData.zmagsSource, null, zmagsData.qty);
	}

	function trackGoToCheckout() {
		var action = 'Zmags Checkout';
		trackZmagsEvent(action, zmagsData.zmagsSource, null, zmagsData.qty);
	}

	function trackOrderPlaced() {
		var action = 'Zmags Order Placed';
		trackZmagsEvent(action, zmagsData.zmagsSource, null, zmagsData.qty);
	}

	/**
	 * Actual tracking requests to Google and/or Adobe are issued here.
	 */
	function trackZmagsEvent(action, zmagsSource, pid, qty) {
		
		function clearAdobeVars(s) {
			for (var i = 0; i < 75; i++) {
				s['prop' + i] = '';
				s['eVar' + i] = '';
				if (i <= 5) {
					s['hier' + i] = '';
				}
			}
			svarArr = ['pageName','channel','products','events','campaign','purchaseID','state','zip','server','linkName'];
			for (var i = 0; i < svarArr.length ; i++) {
				s[svarArr[i]] = ''; 
			}
		}
		
		var label = pid ? pid + ', ' + zmagsSource : zmagsSource,
			category = 'Zmags DW cartridge',
			s, 
			s_code;
		
		if (isGoogleAnalyticsEnabled()) {
			// Google Analytics: 
			if (qty) {
				ga(ZMAGSSOURCE + '.send', 'event', category, action, label, qty);
			} else {
				ga(ZMAGSSOURCE + '.send', 'event', category, action, label);
			}
		}
		if (isAdobeAnalyticsEnabled()) {
			// Adobe Analytics:
			s = window.__zmags.demandware.analytics[ZMAGSSOURCE].AppMeasurementInstance;
			clearAdobeVars(s);
			s.channel = category;
			s.pageName = action;
			s.prop1 = ZMAGSSOURCE;
			s.prop2 = action;
			s.prop3 = label;
			if (pid) {
				s.products = pid;
			}
			if (qty) {
				s.prop4 = qty;
			}
			s_code = s.t();
			if (s_code) {
				document.write(s_code);
			}
		}
	}

	function isQuickviewCall(url) {
		return url.indexOf('source=quickview') > -1;
	}

	function isZmagsSource(url) {
		if (url) {
			return url.indexOf('?zmagssrc=' + ZMAGSSOURCE) > -1 || url.indexOf('&zmagssrc=' + ZMAGSSOURCE) > -1;
		} else {
			return false;
		}
	}

	function isAddProductCall(url, options) {
		var result = url.indexOf('Cart-AddProduct') > -1 && url.indexOf('format=ajax') > -1;
		if (!result) {
			result = url.indexOf('Cart-MiniAddProduct') > -1 && options.data.indexOf('pid=') > -1;
			if (result) {
				options.data += '&zmagssrc=' + ZMAGSSOURCE;
			}
		}
		return result; 
	}

	function isProductVariationCall(url) {
		return url.indexOf('Product-Variation') > -1 || url.indexOf('Product-GetSetItem') > -1;
	}

	function isGoogleAnalyticsEnabled() {
		return zmagsSettings.googleAnalyticsEnabled;
	}

	function isAdobeAnalyticsEnabled() {
		return zmagsSettings.adobeAnalyticsEnabled;
	}

	function isTrackingEnabled() {
		return isGoogleAnalyticsEnabled() || isAdobeAnalyticsEnabled();
	}

	/**
	 * Indicates whether Zmags Publicator Cartridge is used and currently also tracking events
	 */
	function isZmagsPublicatorTrackingActive() {
		var zmagsPublicatorData = window.__zmags.demandware.analytics.publicator && window.__zmags.demandware.analytics.publicator.data;
		return zmagsPublicatorData && zmagsPublicatorData.zmagsSource;
	}

	/**
	 * Retrieves the parameter value for name from url.
	 * f.e. getParameterByName('abc?x=123&y456', 'x') returns '123'
	 * @returns {string} parametervalue for given name
	 */
	function getParameterByName(url, name) {
		var query = null;
		var splittedUrl = url.split('?');
		if (splittedUrl.length > 1) {
			query = splittedUrl[1];
		} else {
			query = url;
		}
		query = query.split('&');
		var parameterValue = null;
		$.each(query, function(i,value){
			var token = value.split('=');
			if (token.length > 1) {
				var key = decodeURIComponent(token[0]);
				if (key === name) {
					parameterValue = decodeURIComponent(token[1]);
					return false; //-> break out of $.each 
				}
			}
		});
		return parameterValue;
	}

	/**
	 * Retrieves the quickview object 
	 * @returns {object} quickview
	 */
	function getQuickview() {
		var quickview = window.__zmags && window.__zmags.demandware && window.__zmags.demandware.quickview || null;
		return quickview;
	}

	/**
	 * Retrieves the page namespace 
	 * @returns {string} pageNamespace
	 */
	function getPageNamespace() {
		var pageNamespace = pageContext && pageContext.ns || null;
		return pageNamespace;
	}

	/**
	 * Track the quickview opened event and append a zmagssrc hidden field to quickview form(s)
	 */
	function handleQuickviewOpened(url) {
		var $contentWrapper = $('#pdpMain'),
			zmagsSource = getParameterByName(url, 'zmagssrc'),
			pid = getParameterByName(url, 'pid') || $contentWrapper.find('span[itemprop=productID]').html(),
			$subProductForms = $('#QuickViewDialog .add-sub-product form');
		
		trackQuickviewOpened(pid, zmagsSource);

		if ($contentWrapper.data('zmagssrc') == null) {
			$contentWrapper.data('zmagssrc', zmagsSource);
			appendZmagsHiddenField();
		}
		
		// If the Quickview displays a product set then the add-to-cart button for a single product 
		// of that set will submit a form and redirect to the cart page.
		// This means that in this case no AJAX call is issued, so we have to track this add-to-cart event 
		// by listening to the form-submit event:
		if ($subProductForms.length) {
			$subProductForms.on('submit.zmags' + ZMAGSSOURCE, function() {
				var $form = $(this),
					qty = $form.find('input[name="Quantity"]').val(),
					pid = $form.find('input[name="pid"]').val();
				trackAddToCart(pid, zmagsSource, qty);
			});
		}
	}

	/**
	 * Track an added-to-cart event.
	 */
	function handleProductAdded(query) {
		var zmagsSource = getParameterByName(query, 'zmagssrc'),
			pid = getParameterByName(query, 'pid'),
			qty = getParameterByName(query, 'Quantity');
		
		trackAddToCart(pid, zmagsSource, qty);
	}

	/**
	 * This callback is executed for all completed AJAX requests. 
	 * Here we check the request URL to see 
	 * - if we need to prepare a newly opened quickview dialog or
	 * - if we need to send a tracking request. 
	 */
	function ajaxCompleteCallback(e, xhr, options) {
		var url = options.url;
		// check if quickview was opened by zmags
		if (isQuickviewCall(url) && isZmagsSource(url)) {
			handleQuickviewOpened(url);
		} else if (isAddProductCall(url, options)) {
			if (isZmagsSource(options.data)) {
				handleProductAdded(options.data);
			} else if (isZmagsSource(url)) {
				handleProductAdded(url);
			}
		} else if (isProductVariationCall(url)) {
			// on swatch click the whole form gets overwritten, with the response of the Product-Variation call.
			// so we need to append the zmagssrc hidden field again
			appendZmagsHiddenField();
		}
	}

	/**
	 * Append a hidden zmagssrc input field to each form on the quickview page.
	 * This parameter will be sent to the server on add to cart clicks
	 */
	function appendZmagsHiddenField() {
		var $contentWrapper = $('#pdpMain'),
			$form = $contentWrapper.find('form'),
			zmagsSource = $contentWrapper.data('zmagssrc');
		if (zmagsSource != null) {
			$form.each(function(){
				if ($(this).find('input[name=zmagssrc]').length == 0) {
					$('<input type="hidden" name="zmagssrc" value="' + zmagsSource + '">').appendTo($(this));
				}
			});
		}
	}

	/**
	 * Public initialization function
	 */
	function init() {
		if (isTrackingEnabled()) {
			initializeAnalytics();
		}
	}

	/**
	 * Private initialization function, registering callbacks, firing events
	 */
	function initializeAnalytics() {
		var quickview = getQuickview();
		if (quickview != null) {
			// register callback which fires after an ajax requested has completed
			$(document).ajaxComplete(ajaxCompleteCallback);
		} else {
			console.log('Zmags Creator Analytics Error: quickview == null');
		}

		var pageNamespace = getPageNamespace();
		if (pageNamespace && zmagsData.zmagsSource === ZMAGSSOURCE) {
			var $wrapper = $('#wrapper');
			if (pageNamespace === 'cart' && $wrapper.find('#cart-items-form').length > 0) {
				trackCartViewed();
			} else if (pageNamespace === 'orderconfirmation' ) {
				trackOrderPlaced();
			}
			// add listener to checkout buttons, listener is unbound after its first invocation
			$wrapper.one('click', '[name$=_cart_checkoutCart], .mini-cart-link-checkout', function(e) {
				e.preventDefault();
				trackGoToCheckout();
				//if zmags publicator also tracking this event don't click on checkout button because it will result in 3 events and not 2
				if (!isZmagsPublicatorTrackingActive()) {
					e.target.click();
				}
			});
		}
	}

	module.exports = init;
}());
